import React from 'react'
import {connect} from 'react-redux'
import PropTypes from 'prop-types'
import queryString from 'querystring'

import ConfirmEmail from '../components/ConfirmEmail'
import actions from '../actions/confirmEmail'

class ConfirmEmailContainer extends React.Component {

  constructor(props) {
    super(props)

    const search = props.location.search
    const query = queryString.parse(search.substring(1, search.length))

    if (typeof query.code === 'undefined' || query.code === '') {
      props.history.push('/')
      return
    }

    if (typeof query.email === 'undefined' || query.email === '') {
      props.history.push('/')
      return
    }

    props.save(query.code, query.email)
  }

  render() {
    return <ConfirmEmail {...this.props}/>
  }
}

ConfirmEmailContainer.propTypes = {
  location: PropTypes.object,
  save: PropTypes.func,
}

const mapStateToProps = state => {
  const data = state.ui.confirmEmail.confirmEmail
  return {
    isSaving: data.get('isSaving'),
    error: data.get('error'),
  }
}

const mapDispatchToProps = dispatch => {
  return {
    save: (code, email) => dispatch(actions.save(code, email)),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailContainer)



// WEBPACK FOOTER //
// ./src/sections/confirmEmail/containers/confirmEmail.js